import React from 'react';
import ImageBlurFallback from '../../Components/ImageBlurFallback';
import GIVEAWAY_IMG from '../../Assets/v2/workshop/giveaway.png';
import './style.css';

const GIVEAWAY_DATA = [
  'Ever thought of trying your hands on programming? Never knew how to start?',
  'We have got you covered. We will train you to start your career in programming.',
  'It will be a Two days workshop along with a doubt session. Not only you learn but if you perform extraordinary and secure your position among the top 10 rank holders. You secure an internship with a PPO opportunity.'
];
const Giveaways = () => (
  <section className="workshop-giveaways-parent-container">
    <div className="workshop-giveaways-child-container">
      <div className="workshop-giveaways-child-left">
        <p className="workshop-giveaways-header">Giveaway:-</p>
        {GIVEAWAY_DATA.map(giveaway => (
          <p className="workshop-giveaways-text">{giveaway}</p>
        ))}
        <br />
      </div>
      <div className="workshop-giveaways-child-right">
        <ImageBlurFallback
          src={GIVEAWAY_IMG}
          alt="Giveaway"
          className="workshop-giveaway-image"
        />
      </div>
    </div>
  </section>
);

export default Giveaways;



// WEBPACK FOOTER //
// ./src/Pages/Workshop/Giveaways.js